import { useContext, useEffect, useState } from 'react';

import { DataContext } from 'providers/data';
import { itemProduct } from 'utils/typeServices';
import { LoadConfig } from 'utils/loadConfig';

import PackageCard from './PackageCard';
import Typography from '@mui/material/Typography';
import BoxMui from '@mui/material/Box';

import { Container, Box } from './styles';

const ServicePackages = () => {
    const { dataQuoteListservices } = useContext(DataContext);
    const [itemsServicePackages, setItemsServicePackages] = useState<Array<itemProduct>>([]);

    const filterNonEligiblePlatinumProducts = (items: Array<itemProduct>) => {
        const PLATINUM_PRODUCTS = LoadConfig().REACT_APP_PLATINUM_PRODUCTS;

        return items
            .filter(({ vL_TOTAL }) => parseFloat(vL_TOTAL.split(' ')[1].replace(',', '.')) > 0)
            .filter(({ cD_PRODUTO }) => !PLATINUM_PRODUCTS.includes(cD_PRODUTO));
    }

    useEffect(() => {
        if (dataQuoteListservices) {
            setItemsServicePackages([]);
            let array: itemProduct[] = [];

            // eslint-disable-next-line array-callback-return
            dataQuoteListservices.cotacaO_ITEMS.map(({ nR_TIPO_PRODUTO, nM_PRODUTO }, index) => {
                if (nR_TIPO_PRODUTO === 13 && nM_PRODUTO?.includes("Pacote")) {
                    array.push(dataQuoteListservices.cotacaO_ITEMS[index]);
                }
            });

            const filtered = filterNonEligiblePlatinumProducts(array);
            const arraySort = filtered.sort((a, b) => parseFloat(a.vL_TOTAL.split(' ')[1].replace(',', '.')) - parseFloat(b.vL_TOTAL.split(' ')[1].replace(',', '.')));
            setItemsServicePackages(arraySort);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataQuoteListservices]);

    return (
        <Container>
            {itemsServicePackages.length > 0 &&
                <BoxMui sx={{ margin: '2.5rem 0 3.125rem' }}>
                    <Typography variant='h5' fontWeight={700} marginBottom='1.625rem'>
                        Pacotes de serviços:
                    </Typography>

                    <Box>
                        {itemsServicePackages?.map(({ nM_PRODUTO, vL_TOTAL, cD_PRODUTO, dS_PRODUTO, cD_COTACAO_ITEM, nR_TIPO_PRODUTO, vL_COMISSAO_MINIMO, nR_PORCENTAGEM_INDENIZACAO }, index) => (
                            <PackageCard
                                key={index}
                                title={nM_PRODUTO}
                                descriptionList={dS_PRODUTO}
                                codProductSingle={cD_PRODUTO}
                                cdQuotationItem={cD_COTACAO_ITEM}
                                nrTypeProduct={nR_TIPO_PRODUTO}
                                price={vL_TOTAL.replace('R$', '')}
                                VL_COMISSAO={vL_COMISSAO_MINIMO}
                                nR_PORCENTAGEM_INDENIZACAO={nR_PORCENTAGEM_INDENIZACAO}
                            />
                        ))}
                    </Box>
                </BoxMui>
            }
        </Container >
    )
}

export default ServicePackages;